module.exports = __webpack_public_path__ + "img/expovina_03.518164ad.jpg";